import { createAction, props } from '@ngrx/store';

export const setCurrentProduct = createAction(
  '[Navigation] Set Current Product',
  props<{ productUuid: string; category: string }>()
);

export const clearCurrentProduct = createAction(
  '[Navigation] Clear Current Product'
);

export const setLoading = createAction(
  '[Navigation] Set Loading',
  props<{ isLoading: boolean }>()
);

export const setCurrentCategory = createAction(
  '[Navigation] Set Current Category',
  props<{ category: string }>()
);

export const clearCurrentCategory = createAction(
  '[Navigation] Clear Current Category'
);